import { TableHead, TableRow, TableCell } from "@mui/material";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";


const PartOffersTableHead = () => {

    const headCells = [
        { name: "Ime prodavca", align: "left" },
        { name: "Lokacija", align: "left" },
        { name: "Nacin dostave", align: "left" },
        { name: "Garancija", align: "left" },
        { name: "Cena", align: "right" },
        { name: "Opis", align: "left" },
    ];

    return (
        <TableHead sx={{}}>
            <TableRow>
                {headCells.map((headCell, i) => (
                    <TableCell
                        key={i}
                        align={headCell.align}
                    >
                        <div>
                            <p style={styles.tableHeadText}>
                                {headCell.name}
                            </p>
                        </div>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
};

export default PartOffersTableHead;


const styles = {
    tableHeadText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "14px"
    }
}